/** @jsx jsx */
import { jsx } from "theme-ui"

export const Body = ({ children, ...props }) => (
  <p
    sx={{
      variant: "typography.sizing.bodyCopy",
      ...props.style
    }}
  >
    {children}
  </p>
)

export default Body

export const BodyLarge = ({ children, ...props }) => (
  <p
    sx={{
      variant: "typography.sizing.bodyCopyLarge",
      ...props.style,
      lineHeight: 1.45
    }}
  >
    {children}
  </p>
)
